import React from "react";
import DefaultLayout from "../../components/layout/DefaultLayout";
import {ValidatorForm} from "react-material-ui-form-validator";
import FormBlocContainer from "../../components/layout/form/FormBlocContainer";
import LastnameInput from "../../components/layout/form/inputs/text/LastnameInput";
import SSDateInput from "../../components/layout/form/inputs/date/SSDateInput";
import NumSSInput from "../../components/layout/form/inputs/text/NumSSInput";
import TextInput from "../../components/layout/form/inputs/text/TextInput";
import PhoneInput from "../../components/layout/form/inputs/text/PhoneInput";
import EmailInput from "../../components/layout/form/inputs/text/EmailInput";
import {Box, Button, Divider, Typography} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import DOMHelper from "../../helpers/DOMHelper";
import {useDispatch} from "react-redux";
import {toggleLoading} from "../../store/slices/loadingSlice";
import ContactService from "../../api/extranet/services/ContactService";
import SweetAlert from "sweetalert2";
import {useLocation} from "react-router-dom";
import {useHistory} from 'react-router-dom';
import {Grid} from "@mui/material";


const InsuredContactPage = () => {

    const [state, setState] = React.useState({
        lastname: '',
        ssNum: '',
        birthdate: '',
        numTel: '',
        numDossier: '',
        email: ''
    });


    const mainForm = React.createRef()
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    React.useEffect(() => {


        if (location.state) {
            console.log('Received state from navigation:', location.state); // Log the received data
            setState((prevState) => ({
                ...prevState,
                ...location.state
            }));
        } else {
            console.log('No state received from navigation');
        }
    }, [location.state]);


    const handleChange = (event) => {
        setState(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const sendMail = async () => {
        dispatch(toggleLoading());
        const {lastname, ssNum, birthdate, numTel, numDossier, email} = state;
        const data = {
            context: {
                emailAssure: email,
                lastname: lastname,
                ssNum: ssNum,
                birthdate: birthdate,
                numTel: numTel,
                numDossier: numDossier
            },
        };
        const isEmailSent = await ContactService.sendFailedToCreateInsuredAccountEmail(data);
        dispatch(toggleLoading());
        return isEmailSent;
    }
    const handleSubmitContact = () => {
        mainForm.current.isFormValid(false)
            .then(async (value) => {
                if (value) {
                    const result = await sendMail();
                    if (result.error) {
                        return await SweetAlert.fire({
                            title: 'Un incident est survenu à l\'envoi du mail',
                            text: result.message,
                            type: 'error',
                            confirmButtonText: 'Fermer',
                            confirmButtonColor: '#EF595D'
                        });
                    } else {
                        return await SweetAlert.fire({
                            title: 'Demande transmise',
                            text: "Votre demande va être traitée par le service Gestion",
                            type: 'success',
                            confirmButtonText: 'Fermer',
                            confirmButtonColor: '#EF595D'
                        }).then((confirm) => {
                            if (confirm.value) {
                                history.push("/ui/register/insured");
                            }
                        });
                    }
                } else {
                    DOMHelper.scrollToError();
                }
            })
        ;
    }

    return <DefaultLayout>
        <Box sx={{p: 2, }}>
            <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                Demande de création de compte assuré
            </Typography>
            <Divider   sx={{
                borderColor: '#EF595D',
                my: 1,
                width: '10%',
                borderWidth: '2px',
                marginBottom: '15px',
                marginTop: '15px'
            }} />
            <ValidatorForm
                ref={mainForm}
                onSubmit={handleSubmitContact}
                onError={() => console.error('onError')}
            >
                <FormBlocContainer>

                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} sm={3} sx={{paddingRight: 2, marginBottom: 2}}>
                        <LastnameInput
                            sm={12}
                            label={"Nom*"}
                            name={"lastname"}
                            value={state.lastname}
                            handleChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} sx={{paddingRight: 2, marginBottom: 2}}>
                        <SSDateInput
                            sm={12}
                            ss={state.ssNum}
                            name={"birthdate"}
                            value={state.birthdate}
                            handleChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{paddingRight: 2, marginBottom: 2}}>
                        <NumSSInput
                            sm={12}
                            name={"ssNum"}
                            value={state.ssNum}
                            handleChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} sm={3} sx={{paddingRight: 2, marginBottom: 2}}>
                        <PhoneInput
                            sm={12}
                            label={"N° de téléphone"}
                            name={"numTel"}
                            value={state.numTel}
                            handleChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} sx={{paddingRight: 2, marginBottom: 2}}>
                        <EmailInput
                            sm={12}
                            label={"E-mail*"}
                            name={"email"}
                            value={state.email}
                            handleChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} sx={{paddingRight: 2, marginBottom: 2}}>
                        <TextInput
                            sm={12}
                            label={"N° de dossier"}
                            name={"numDossier"}
                            value={state.numDossier}
                            handleChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={0} sm={1}></Grid>
                    <Grid item xs={12} sm={10}>
                        <Grid container justifyContent="flex-end">
                            <Button type={"submit"} variant="contained" color="primary">
                                Envoyer

                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={0} sm={1}></Grid>
                </FormBlocContainer>
            </ValidatorForm>
        </Box>

    </DefaultLayout>
}


export default InsuredContactPage
